module.exports = __webpack_public_path__ + "img/statistics.8eb963b4.png";